<template>

    <div class="subscription-card">
            <div class="detail-row" v-if="totalSubscriptions > 0">
              <div class="detail-item">Free Shifts</div>
              <div class="detail-value">{{ remainingSubscriptions }}/{{ totalSubscriptions }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-item">Start Date</div>
              <div class="detail-value start-date">{{formatDate(user.subscribedInfos.subscriptionStartDate)}}</div>
            </div>
            <div class="detail-row">
              <div class="detail-item">Renewal Date</div>
              <div class="detail-value end-date">{{formatDate(user.subscribedInfos.subscriptionRenewalDate)}}</div>
            </div>
            <!-- <div class="detail-row">
              <div class="detail-item">Transaction Fee <span class="detail-description">({{ transactionOriginalPrice }}% without subscription)</span>
              </div>
              <div class="detail-value">{{ transactionSubPrice }}%</div>
            </div> -->
            <div class="detail-row">
              <div class="detail-item">Booking Fee</div>
              <div class="detail-value">{{ currencyFormat(bookingSubPrice) }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-item text-bold">Price</div>
              <div class="detail-value">{{ currencyFormat(user.subscribedInfos.subscription.monthlyPrice) }}</div>
            </div>

            <div class="status-tag">
                {{ user.subscribedInfos.subscription.name }}
            </div>
          </div>
</template>

<script>
import {
    onMounted,
    inject,
    ref,
    computed
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";

import {
    useRouter,
    // useRoute
} from "vue-router";

export default {
    directives: {},
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $moment = inject(["$moment"]);
        // const $route = useRoute()
        const setPageClassGlobal = inject("setPageClassGlobal");
        const mainMenuShow = inject("mainMenuShow");

        const user = $store.getters.GET_USER_DATA;
        console.log("🚀 ~ file: Subscription.vue:81 ~ setup ~ user:", user)
        const subscription = ref(user.calculatedSubscriptions.subscription ? user.calculatedSubscriptions.subscription : 0);
        const totalSubscriptions = ref(user.calculatedSubscriptions.totalSubscriptions ? user.calculatedSubscriptions.totalSubscriptions : 0);
        const remainingSubscriptions = ref(user.calculatedSubscriptions.remainingSubscriptions ? user.calculatedSubscriptions.remainingSubscriptions : 0);
        const transactionOriginalPrice = ref(user.calculatedSubscriptions.transactionOriginalPrice ? user.calculatedSubscriptions.transactionOriginalPrice : 0);
        const transactionSubPrice = ref(user.calculatedSubscriptions.transactionSubPrice ? user.calculatedSubscriptions.transactionSubPrice : 0);
        const bookingSubPrice = ref(user.calculatedSubscriptions.bookingSubPrice ? user.calculatedSubscriptions.bookingSubPrice : 0);
        //   const subscriptionDetais = ref(userAgent.subscribedInfos);

        const progressBarWidth = computed(() => {
            const percentage = (remainingSubscriptions.value / totalSubscriptions.value) * 100;
            return `${percentage}%`;
        });

        const currencyFormat = (value) => {
            return new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
            }).format(value);
        };

        const barColor = computed(() => {
            // Define your desired bar color logic here
            return '#2463FF';
        });

        const pieStyle = computed(() => {
            const percentage = (remainingSubscriptions.value / totalSubscriptions.value) * 100;
            return {
                '--p': percentage,
                '--c': barColor.value,
                '--b': '5px'
            };
            });

        const formatDate = (dateString) => {
            const date = $moment(dateString);
            return date.format('D MMM, YYYY'); // Adjust the format as needed
        };

        const goBack = () => {
            $router.push({
                name: "profile",
            });
        };

        onMounted(() => {
            setPageClassGlobal("global_subscription_component");
            mainMenuShow(true);
        });

        return {
            user,
            goBack,
            subscription,
            totalSubscriptions,
            remainingSubscriptions,
            transactionOriginalPrice,
            transactionSubPrice,
            bookingSubPrice,
            progressBarWidth,
            barColor,
            formatDate,
            currencyFormat,
            pieStyle
        };
    },
};
</script>
